import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { List } from 'immutable';

import { Container, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';
import { View } from '@uncinc/react-drupal-core';

import { getVocabulary } from '../../../../store/actions/UI';

const components = {
  // Custom MultiValueContainer to display comma seperated values.
  MultiValueContainer: ({ selectProps: { value }, data: { label } }) => {
    if (value) {
      return value.at(-1)?.label === label ? label : label + ', ';
    }
    return '';
  },
};

const VacanciesDaytimeActivityOverview = ({ display }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({});

  // Load vocabularies into state after mount.
  useEffect(() => {
    dispatch(getVocabulary('daytime_activity_vacancy_types'));
    dispatch(getVocabulary('locations'));
  }, [dispatch]);

  const vacancyTerms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'daytime_activity_vacancy_types'], List()));
  const locationTerms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'locations'], List()));
  const mapTermsToOptions = (terms) => terms.map((term) => ({
    value: term.getIn(['tid', 0, 'value']),
    label: term.getIn(['name', 0, 'value']),
  }));
  const mappedVacancyTerms = mapTermsToOptions(vacancyTerms);
  const mappedLocationTerms = mapTermsToOptions(locationTerms);

  const onChangeType = (selectedTypes) => {
    // Assign the new selected array to the type filter.
    setFilters((state) => ({ ...state, field_daytime_activity_vacancy_t_target_id: selectedTypes }));
    setCurrentPage(0);
  };

  const onChangeLocation = (selectedLocations) => {
    // Assign the new selected array to the location filter.
    setFilters((state) => ({ ...state, field_location_target_id: selectedLocations }));
    setCurrentPage(0);
  };

  return (
    <Container>
      <div className="ParagraphContentOverview">
        <FormikWrapper initialValues={{ types: [], locations: [] }}>
          <div className="row">
            <div className="Select__multi-value col-md-6">
              <Select
                multiple
                hideSelectedOptions={false}
                isClearable={false}
                title={t('vacancy.what_to_do')}
                fieldName="type"
                placeholder={t('vacancy.placeholder_input_type')}
                options={mappedVacancyTerms.toArray()}
                className="Select"
                classNamePrefix="Select"
                onChange={onChangeType}
                components={components}
              />
            </div>

            <div className="Select__multi-value col-md-6">
              <Select
                multiple
                isClearable={false}
                hideSelectedOptions={false}
                title={t('vacancy.where_to_do')}
                fieldName="location"
                placeholder={t('vacancy.placeholder_input_location')}
                options={mappedLocationTerms.toArray()}
                className="Select"
                classNamePrefix="Select"
                onChange={onChangeLocation}
                components={components}
              />
            </div>
          </div>
        </FormikWrapper>

        <View
          id="content_overview"
          display={display}
          page={currentPage}
          setCurrentPage={setCurrentPage}
          type="vacancies"
          filters={filters}
        />
      </div>
    </Container>
  );
};

export default VacanciesDaytimeActivityOverview;
